import { render, staticRenderFns } from "./ruleCard.vue?vue&type=template&id=785502cb&scoped=true&"
import script from "./ruleCard.vue?vue&type=script&lang=js&"
export * from "./ruleCard.vue?vue&type=script&lang=js&"
import style0 from "./ruleCard.vue?vue&type=style&index=0&id=785502cb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785502cb",
  null
  
)

export default component.exports